import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  props: {
    equipmentId: String,
    month: String,
    year: String,
    type: String,
    departmentId: String,
  },

  data: () => ({
    loading: false,
    startDate: null,
    endDate: null,
    institutionId: null,
    serviceOrder: {},
    serviceOrders: [],
    serviceOrderType: null,
    serviceOrderTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
      'Serviços',
      null,
      null,
      null,
      'Serviço Operacional',
    ],
    apiService: new ApiService(),
  }),

  async created() {
      this.startDate = new Date(this.year, this.month - 1, 1)
      this.endDate = new Date(this.getLastDay(this.startDate))

      this.serviceOrderType =
        this.serviceOrderTypes.indexOf(this.type) < 0
          ? this.serviceOrderType
          : this.serviceOrderTypes.indexOf(this.type)
      this.institutionId = JSON.parse(localStorage.getItem('institution')).id

      if (this.equipmentId && this.equipmentId > 0) {
        this.getEquipment()
      } else {
        this.endDate = new Date(this.getLastDay(this.startDate))  
        this.getOSs()
      }
    },

  components: {},

  methods: {
    close() {
      this.$router.go(-1)
    },

    getItemText(value) {
      return value.isPlanning
        ? `Planejamento - ${this.formartDate(value.dateTimeRequest)}`
        : `O.S. n° ${value.number} - ${value.name} - ${this.formartDate(
            value.dateTimeRequest
          )}`
    },

    async getEquipment() {
      this.loading = true
      await this.apiService
        .get(`equipment/${this.institutionId}/${this.equipmentId}`)
        .then((response) => {
          const equipment = response.content
          this.serviceOrders = equipment.serviceOrders
            .filter(
              (x) =>
                new Date(x.dateTimeRequest) >= this.startDate &&
                new Date(x.dateTimeRequest) <= this.endDate &&
                x.serviceOrderType == this.serviceOrderType
            )
            .map((so) => {
              return {
                ...so,
                isPlanning: false,
              }
            })

          this.serviceOrders = [
            ...this.serviceOrders,
            ...equipment.plannings
              .filter(
                (x) =>
                  !x.serviceOrderId &&
                  x.serviceOrderType == this.serviceOrderType &&
                  new Date(x.schedulingDate) >= this.startDate &&
                  new Date(x.schedulingDate) <= this.endDate
              )
              .map((po) => {
                return {
                  id: po.id,
                  name: `Planejamento`,
                  isPlanning: true,
                  planningOSInfo: po.planningOSInfo,
                  dateTimeRequest: po.schedulingDate,
                  ...po,
                }
              }),
          ]

          console.log(this.serviceOrders)
        })
        .catch((err) => {})

      this.loading = false
    },

    async getOSs() {
      this.loading = true

      const model = {
        institutionId: this.institutionId,
        orderType: this.serviceOrderType,
        start: this.startDate,
        end: this.endDate,
        departmentId: this.departmentId ? parseInt(this.departmentId) : null,
      }

      await this.apiService
        .post(`serviceOrder/byPeriod`, model)
        .then((response) => {
          this.serviceOrders = response.content
        })
        .catch((err) => {})

      this.loading = false
    },

    getLastDay(date) {
      return Utils.getLastDay(date)
    },

    formartDate(date) {
      return Utils.dateTime(date)
    },

    serviceOrderSelected() {
      if (this.serviceOrder.isPlanning) {
        if (this.serviceOrder.planningOSInfo) {
          localStorage.setItem(
            `planningOSInfo-${this.serviceOrder.id}`,
            JSON.stringify(this.serviceOrder.planningOSInfo)
          )
        } else {
          localStorage.setItem(
            `planningOSInfo-${this.serviceOrder.id}`,
            JSON.stringify({ responsability: this.serviceOrder.responsability })
          )
        }

        let type = 'Calibração'

        switch (this.serviceOrder.serviceOrderType) {
          case 1:
            type = 'Segurança elétrica'
            break
          case 2:
            type = 'Preventiva'
            break
          case 6:
            type = 'Calibração'
            break
          case 7:
            type = 'Validação/Qualificação'
            break
          default:
            break
        }
        this.$router.push(
          `/newServiceOrder?equipmentId=${this.serviceOrder.equipmentId}&month=${this.month}&year=${this.year}&type=${type}&fromPlanning=true&scheduledDate=${this.serviceOrder.schedulingDate}&planningId=${this.serviceOrder.id}`
        )
      } else {
        this.$router.push(`/editServiceOrder/${this.serviceOrder.id}`)
      }
    },
  },

  watch: {},
}
